import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const New = lazy(() => import('./New'))
const Detail = lazy(() => import('./Detail'))
const Edit = lazy(() => import('./Edit'))

export const TrainingSessionsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--training--sessions']}>
    <Route index element={<Index />} />
    <Route path='new' element={<New />} />
    <Route path=':id' element={<Detail />} />
    <Route path=':id/edit' element={<Edit />} />
  </SubRouter>
))
